module.exports = __webpack_public_path__ + "media/application/images/svgs/download-037084d74b23fbddd4d693da638d999d.svg";